import drawLabelCustomVN from '../helpers/drawLabelCustomVN'
import drawLabelLLCQR from '../helpers/drawLabelLLCQR'
import drawLabelLLC from '../helpers/drawLabelLLC'
import drawLabelTeddy4Life from '../helpers/drawLabelTeddy4Life'
import drawLabelSBFAST from './drawLabelSBFAST'

const LLC_CARRIERS = ['flashship_usps', 'flashship_usps_manual', 'GC_LLC']

// FAC-23754
// Nguồn sự thật DUY NHẤT cho "ảnh label của đơn này là gì".
// Tái hiện đúng thứ tự ưu tiên của ShipOrderDetails._printLabel (KHÔNG có gate canPrint,
// KHÔNG in) để: (1) hiển thị preview, (2) suy ra đơn đã có label hay chưa.
// Trả về src dùng được trực tiếp cho <img src> (dataURL từ canvas hoặc URL file label),
// hoặc null nếu đơn chưa tạo được label.
export const buildLabelSrc = async (item) => {
    if (!item) return null

    const {
        labelDetails,
        barcodeNumber,
        order_type,
        split_fba_item_label,
        first_barcode_in_batch_ship,
        first_batch_ship_box,
        tags = [],
        country = '',
        name,
        address1,
        address2,
        city,
        state,
        postalCode,
    } = item

    // 1. FBA — label thật (ảnh tách FBA)
    if (order_type === 'FBA') {
        return split_fba_item_label || null
    }

    // 2. VN — hệ thống tự vẽ thuần từ địa chỉ đơn
    if (country === 'VN') {
        return await drawLabelCustomVN({
            barcodeNumber, name, address1, address2, city, country, state, postalCode,
        })
    }

    // 3. Theo carrier
    if (!(labelDetails instanceof Object)) return null
    const { url, shipping_carrier, partnerTrackingNumber, trackingNumber } = labelDetails

    // 3a. LLC/flashship — vẽ canvas nhưng cần partnerTrackingNumber
    if (LLC_CARRIERS.includes(shipping_carrier)) {
        if (!partnerTrackingNumber) return null
        return await drawLabelLLCQR(item)
    }

    // 3b. ib_blue — cần partnerTrackingNumber
    if (shipping_carrier === 'ib_blue') {
        if (!partnerTrackingNumber) return null
        return await drawLabelLLC(barcodeNumber, partnerTrackingNumber, 'ib_blue')
    }

    // 3c. SB_FAST — hệ thống tự vẽ từ box lô ship (carrier nằm trên first_barcode_in_batch_ship)
    if (first_barcode_in_batch_ship && first_batch_ship_box) {
        const fbCarrier = first_barcode_in_batch_ship.labelDetails
            && first_barcode_in_batch_ship.labelDetails.shipping_carrier
        if (fbCarrier === 'SB_FAST') {
            return await drawLabelSBFAST(first_barcode_in_batch_ship, first_batch_ship_box)
        }
    }

    // 3d. teddy_4_life — ưu tiên label vẽ từ trackingNumber, thiếu thì rơi xuống url (giữ behavior cũ)
    if (shipping_carrier === 'teddy_4_life' && trackingNumber) {
        return await drawLabelTeddy4Life({ trackingNumber, barcodeNumber })
    }

    // 3e. Mặc định — label xịn (file của carrier)
    if (!url) return null

    let labelFile = url
    const hasShipByTiktokTag = tags.some(t => t === 'shipbytiktok')
    if (hasShipByTiktokTag && url.includes('s3.us-west-1.amazonaws.com')) {
        labelFile = url.replace(
            'https://merchize-artworks.s3.us-west-1.amazonaws.com',
            'https://d22stb37tnopyt.cloudfront.net'
        )
    }
    return labelFile
}

// FAC-23754
// "Hệ thống tự vẽ label" theo chốt với PO (GAP-01): CHỈ gồm VN và SB_FAST — các loại này
// vẽ thuần từ data đơn/box, không phụ thuộc tracking ngoài nên luôn có thể tạo label.
// LLC/flashship/ib_blue/teddy tuy cũng vẽ canvas nhưng cần tracking → KHÔNG tính là tự vẽ.
export const isSystemDrawnType = (item) => {
    if (!item) return false
    if (item.country === 'VN') return true

    const carrier = item.labelDetails && item.labelDetails.shipping_carrier
    const fbCarrier = item.first_barcode_in_batch_ship
        && item.first_barcode_in_batch_ship.labelDetails
        && item.first_barcode_in_batch_ship.labelDetails.shipping_carrier

    return carrier === 'SB_FAST' || fbCarrier === 'SB_FAST'
}

// FAC-23754
// Trạng thái label dùng cho khu vực preview/cảnh báo khi scan item đầu tiên.
// - hasLabel: đơn đã tạo được label (label thật hoặc tự vẽ) → hiển thị preview
// - isSystemDrawn: thuộc loại hệ thống tự vẽ → KHÔNG cảnh báo dù tạm thời chưa có label
export const resolveLabelStatus = async (item) => {
    const src = await buildLabelSrc(item)
    return {
        hasLabel: !!src,
        isSystemDrawn: isSystemDrawnType(item),
        src,
    }
}
